import { fetchData } from "./apiService";

const API_BASE_URL = process.env.REACT_APP_API_ROUTE;

// Función para construir la URL base con prefijo /keycloak si es localhost
const buildKeycloakUrl = (endpoint) => {
  const keycloakPrefix = API_BASE_URL.includes('localhost') ? '/keycloak' : '';
  return `${keycloakPrefix}${endpoint}`;
};

/**
 * Assembles the request headers with token and acquirer information
 * @param {string} token 
 * @param {Object} acquirerData 
 * @returns {Object} 
 */
const buildHeaders = (token, acquirerData) => ({
  Accept: "application/json",
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
  acquirerName: acquirerData.acquirerName,
  acquirerID: acquirerData.acquirerId,
});

/**
 * Checks if the user already exists in Keycloak
 * @param {Object} params
 * @param {string} params.username
 * @param {string} params.email
 * @param {string} params.token
 * @param {Object} params.acquirerData
 * @returns {Promise<boolean>}
 */
export const checkUserExists = async ({ username, email, token, acquirerData }) => {
  const endpoint = buildKeycloakUrl("/user-exists");
  const headers = buildHeaders(token, acquirerData);
  const payload = {
    version: "04.09.01",
    username,
    email,
  };

  try {
    const response = await fetchData({ endpoint, data: payload, headers, token });

    if (response.status !== 200) {
      throw new Error(`Failed to verify user: ${response.statusText}`);
    }

    return !!(response.data && response.data.exists);
  } catch (error) {
    throw new Error(`Error checking Keycloak user: ${error.message}`);
  }
};

/**
 * Create a user in Keycloak.
 * @param {Object} data - 
 * @param {string} token
 * @param {Object} acquirerData
 * @returns {Promise<Object>} 
 */
export const createUserInKeycloak = async (data, token, acquirerData) => {
  const endpoint = buildKeycloakUrl("/create-user");
  const headers = buildHeaders(token, acquirerData);

  try {
    await fetchData({ endpoint, data, headers, token });

    return {
      success: true,
      message: "User created and password update email sent successfully.",
    };
  } catch (error) {
    throw new Error(`Error creating user in Keycloak: ${error.message}`);
  }
};
